// src/utils/canonical.js
// <link rel="canonical"> の一つの情報源。gatsby-ssr.js（HTML）と gatsby-browser.js（サイト内の移動）が使う。
// どのページも URL のパスだけを正規にする（?year= ?month= ?genreName= は同じページの表示の違い）。
// 例外は /artist/: ?artistName= はサークルごとに別のページで、検索からの入口になっている。
// HTML は1枚しかないのでクエリを知らない。Google は JS で HTML の canonical を別の値に変えないよう求めているので、
// /artist/ だけ HTML に canonical を出さず、JS で1つだけ出す。
export const SITE_URL = "https://doujinanalytica.com"

export const isArtistSearchPath = pathname =>
  pathname === "/artist/" || pathname === "/artist"

export const canonicalHref = ({ pathname, search = "" }) => {
  if (!isArtistSearchPath(pathname)) return `${SITE_URL}${pathname}`
  const name = new URLSearchParams(search).get("artistName")?.trim()
  return name
    ? `${SITE_URL}/artist/?artistName=${encodeURIComponent(name)}`
    : `${SITE_URL}/artist/`
}

export const updateCanonical = location => {
  let link = document.querySelector("link[rel='canonical']")
  if (!link) {
    link = document.createElement("link")
    link.setAttribute("rel", "canonical")
    document.head.appendChild(link)
  }
  link.setAttribute("href", canonicalHref(location))
}
